const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto'
  },
  table: {

  },
  button: {
    ...theme.typography.button,
    fontSize: '12px',
    fontWeight: '400',
    letterSpacing: '0.5px',
  },
  title: {
    fontSize: '2em'
  },
  RFsubtestContainer: {
    textAlign: 'center',
    height: '235px'
  },
  cardContent: {
    padding: '0px !important'
  },
  cardActions: {
    padding: '4px 4px',
    height: 'auto'
  },
  cardActionsTitle: {
    background: '#005795 !important',
    padding: '5px',
    textAlign: 'center'
  },
  subtestpassed: {
    background: '#4caf50 !important',
    padding: '5px',
    textAlign: 'center'
  },
  subtestfailed: {
    background: '#ff5252 !important',
    padding: '5px',
    textAlign: 'center'
  },
  subtesttitle: {
    color: '#FFFFFF'
  },
  cardActionsNav: {
    background: '#FF643B !important',
    padding: '5px',
    textAlign: 'center'
  },
  nav: {
    padding: 'initial',
    minWidth: 'initial',
    minHeight: 'initial'
  },
  borderpassed: {
    border: '2px solid #4caf50'
  },
  borderfailed: {
    border: '2px solid #ff5252'
  },
  tablerow: {
    height: '15px'
  },
  tableheader: {
    padding: '8px 5px 9px 5px'
  },
  title: {
    fontSize: '2em'
  },
})

export default styles
